import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'

interface HeaderAssignmentTemplatesReturn {
  refConfig: ComputedRef<LinkBreadcrumbItem[]>
}

export const useHeaderAssignmentTemplates = (): HeaderAssignmentTemplatesReturn => {
  const refConfig = computed<LinkBreadcrumbItem[]>(() => [
    {
      id: 'assignment-templates',
      text: 'Assignment templates',
      to: AppRoute.Assignments,
      disabled: true,
    },
  ])

  return {
    refConfig,
  }
}
